import { getCookies, setCookie } from '../../store/cookies.js';

export const formatPrice = price => {
	if (Number.isNaN(price)) {
		return '?';
	}
	// Round using exponential notation to avoid binary floating-point approximation
	const roundedValue = Number(`${Math.floor(`${price}e2`)}e-2`);
	return roundedValue.toFixed(2);
};

const HIGHLIGHT_GAMES_ONBOARDING_DISABLED_COOKIE = 'hgOnboardingDisabled';
const HIGHLIGHT_GAMES_ONBOARDING_CLOSED_COOKIE = 'hgOnboardingClosed';

export const getOnboardingClosedCookie = () => {
	return getCookies(HIGHLIGHT_GAMES_ONBOARDING_CLOSED_COOKIE);
};

export const setOnboardingClosedCookie = () => {
	setCookie(HIGHLIGHT_GAMES_ONBOARDING_CLOSED_COOKIE, true);
};

export const getOnboardingDisabledCookie = () => {
	const cookie = getCookies(HIGHLIGHT_GAMES_ONBOARDING_DISABLED_COOKIE);
	return cookie || false;
};

/**
 * @typedef {Object} taxationRule
 * @property {number} value
 * @property {number} valuePercentage
 * @property {?number} limit
 * @property {string} type
 */

/**
 * Calculates all amounts for a bet.
 *
 * @param {Number} amount
 * @param {Number} price
 * @param {taxationRule} betAmountTaxationRule
 * @param {taxationRule} winOverLimitTaxationRule
 */
export const calculateTaxationAmounts = (amount, price, betAmountTaxationRule, winOverLimitTaxationRule) => {
	const amountAfterTaxation = betAmountTaxationRule ? amount * betAmountTaxationRule.value : amount;
	const amountTaxation = Number(`${Math.round(`${amount - amountAfterTaxation}e2`)}e-2`);
	const returnAmountBeforeTaxation = amountAfterTaxation * price;
	const returnAmount =
		winOverLimitTaxationRule && returnAmountBeforeTaxation > winOverLimitTaxationRule.limit
			? returnAmountBeforeTaxation * winOverLimitTaxationRule.value
			: returnAmountBeforeTaxation;
	const returnAmountTaxation = Number(`${Math.round(`${returnAmountBeforeTaxation - returnAmount}e2`)}e-2`);

	return {
		amount,
		amountAfterTaxation,
		amountTaxation,
		returnAmountBeforeTaxation,
		returnAmount,
		returnAmountTaxation
	};
};

/**
 * @typedef {Object} bet
 * @property {number} amount
 * @property {number} price
 */

/**
 * @param {bet[]} bets
 * @param {taxationRule} betAmountTaxationRule
 * @param {taxationRule} winOverLimitTaxationRule
 */
export const extendBetsWithTaxedAmountsAndPossibleWin = (bets, betAmountTaxationRule, winOverLimitTaxationRule) => {
	if (bets.lenght < 1) {
		return bets;
	}

	return bets.map(bet => {
		const { returnAmount, amountTaxation, returnAmountTaxation } = calculateTaxationAmounts(
			bet.amount,
			bet.price,
			betAmountTaxationRule,
			winOverLimitTaxationRule
		);

		return {
			...bet,
			possibleWin: returnAmount,
			taxedAmount: amountTaxation,
			taxedWinAmount: returnAmountTaxation
		};
	});
};
